import * as PIXI from "pixi.js";
import SpriteGenerator from "../generators/SpriteGenerator";

export function loadGameScence({ resources, stage, renderer }) {
  const gameScence = new PIXI.Container();

  const { width } = renderer.screen;

  /* Background */
  gameScence.addChild(
    SpriteGenerator({
      width: width,
      height:
        width *
        (resources.background.texture.height /
          resources.background.texture.width),
      texture: resources.background.texture
    })
  );
  stage.addChild(gameScence);

  return gameScence;
}
